import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const fuluCategories = [
  {
    id: 'qiucai',
    title: '求财符箓',
    desc: '财运亨通，生意兴隆',
    image: '/images/fulu/fulu_qiucai1.png',
    route: '/fulu/qiucai'
  },
  {
    id: 'qiuguan',
    title: '求官符箓',
    desc: '仕途升迁，金榜题名',
    image: '/images/fulu/fulu_qiuguan1.png',
    route: '/fulu/qiuguan'
  },
  {
    id: 'xueye',
    title: '学业符箓',
    desc: '学业进步，金榜题名',
    image: '/images/fulu/fulu_xueye1.png',
    route: '/fulu/xueye'
  }
];

const FuluList = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-purple-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          {/* 返回按钮和首页链接 */}
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-indigo-800 hover:text-indigo-600 transition-colors"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              返回
            </button>
            <Link
              to="/"
              className="flex items-center text-indigo-800 hover:text-indigo-600 transition-colors"
            >
              <Home className="w-5 h-5 mr-2" />
              首页
            </Link>
          </div>

          <h1 className="text-4xl font-bold text-center text-indigo-900 mb-4 font-serif">
            符 箓 典 籍
          </h1>
          <p className="text-center text-gray-500 mb-12">道家符箓，趋吉避凶</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {fuluCategories.map((item) => (
              <Link
                key={item.id}
                to={item.route}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden"
              >
                <div className="aspect-square bg-gradient-to-br from-indigo-100 to-purple-100 flex items-center justify-center p-8">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="hidden w-24 h-24 rounded-full bg-indigo-200 items-center justify-center">
                    <span className="text-4xl">符</span>
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-indigo-900 mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-sm">{item.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuluList;
